// kitchnworx — UK's 1st Indian Virtual Kitchen Franchise

export const DUM_LOGO_URL = "https://customer-assets.emergentagent.com/job_14a88942-c248-48e0-ba32-ac2e11833bfe/artifacts/58bplag8_4383EF84-67C0-40B2-932B-73554ACFA62C.PNG";

export const BRAND_NAME = "kitchnworx";
export const BRAND_TAGLINE = "UK's 1st Indian Virtual Kitchen Franchise";

export const NAV_ITEMS = [
  { label: "Why Us", href: "#why" },
  { label: "Brands", href: "#brands", hasDropdown: true },
  { label: "Process", href: "#process" },
  { label: "Requirements", href: "#requirements" },
  { label: "FAQs", href: "#faqs" },
];

export const HERO_STATS = [
  { value: "1st", label: "UK Indian Virtual Kitchen Franchise" },
  { value: "4", label: "Halal Brands From One Kitchen" },
  { value: "100%", label: "Halal & Alcohol-Free" },
  { value: "25m²", label: "Minimum Kitchen Footprint" },
];

export const VIRTUAL_BRANDS = [
  {
    id: 1,
    name: "Dum on the Run",
    cuisine: "Signature Biryani",
    tagline: "Slow-cooked, sealed and on the move.",
    description: "Our flagship brand. Hand-layered Dum biryani, marinated overnight and steam-sealed for that restaurant-grade aroma – delivered in minutes.",
    accent: "#14E0BF",
    bg: "#0F1F1B",
    image: "https://images.unsplash.com/photo-1589302168068-964664d93dc0",
    isFeatured: true,
    bestSellers: ["Hyderabadi Lamb Dum", "Awadhi Chicken Dum", "Veg Dum Pulao"],
  },
  {
    id: 2,
    name: "Tandoor King",
    cuisine: "Tandoori Grills & Kebabs",
    tagline: "Royal flame, modern delivery.",
    description: "Charcoal-fired tandoori chicken, succulent seekh kebabs and pillowy naans – the smoky stars of every Indian feast.",
    accent: "#F77F00",
    bg: "#1F1208",
    image: "https://images.unsplash.com/photo-1610057099431-d73a1c9d2f2f",
    bestSellers: ["Tandoori Half Chicken", "Lamb Seekh Kebab", "Garlic Naan"],
  },
  {
    id: 3,
    name: "Curry Quarter",
    cuisine: "Classic Indian Curries",
    tagline: "A curry for every craving.",
    description: "From silky butter chicken to fiery vindaloo and comforting tarka dal – the comfort-food classics that British customers crave again and again.",
    accent: "#E63946",
    bg: "#1F0B0E",
    image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe",
    bestSellers: ["Butter Chicken", "Lamb Rogan Josh", "Paneer Tikka Masala"],
  },
  {
    id: 4,
    name: "Street Chaat Co.",
    cuisine: "Indian Street Food",
    tagline: "Mumbai pavement to your sofa.",
    description: "Crispy samosas, tangy pani puri shots, loaded chaats and pav bhaji – the flavours of Indian street corners, perfectly portioned for delivery.",
    accent: "#9D4EDD",
    bg: "#150B1F",
    image: "https://images.unsplash.com/photo-1631451457509-454a498df1c0",
    bestSellers: ["Loaded Sev Puri", "Pav Bhaji", "Samosa Chaat"],
  },
];

export const MARKET_STATS = [
  { value: "£4.2B", label: "UK Indian takeaway market size", source: "IBISWorld 2024" },
  { value: "#1", label: "Most-ordered cuisine in the UK", source: "Just Eat Trends" },
  { value: "78%", label: "YoY growth in dark-kitchen delivery", source: "Deliveroo Insights" },
  { value: "1 in 7", label: "UK takeaways serve Indian cuisine", source: "FSA Register" },
];

export const PROCESS_STEPS = [
  {
    id: "01",
    title: "Apply in 60 seconds",
    description: "Tell us about your kitchen, postcode and ambition. No CV. No franchise jargon. Just one short form.",
    icon: "FileText",
    duration: "1 min",
  },
  {
    id: "02",
    title: "Kitchen audit & match",
    description: "Our team visits (or video-tours) your kitchen, checks halal compliance, FSA rating and capacity, and matches you with the right virtual brands for your area.",
    icon: "ClipboardCheck",
    duration: "1 week",
  },
  {
    id: "03",
    title: "Onboard & launch",
    description: "We deliver recipes, packaging, marketing playbooks and platform setup on Deliveroo, Uber Eats and Just Eat. Two days of live training. Then we go live.",
    icon: "Rocket",
    duration: "14 days",
  },
  {
    id: "04",
    title: "You cook, we grow",
    description: "Your dedicated Operations Manager runs ad spend, optimises menu performance and unlocks new brands as you scale. You focus on the food.",
    icon: "TrendingUp",
    duration: "Ongoing",
  },
];

export const REQUIREMENTS = [
  {
    id: 1,
    title: "Fully halal kitchen",
    subtitle: "100% halal menu with no alcohol on premises (including 'bring your own').",
    icon: "ShieldCheck",
  },
  {
    id: 2,
    title: "Commercial setup",
    subtitle: "A real commercial kitchen with extraction, gas or 3-phase power. Not from home, not from a coffee shop.",
    icon: "ChefHat",
  },
  {
    id: 3,
    title: "3+ star FSA rating",
    subtitle: "Active Food Standards Agency rating of 3 stars or higher. We'll help you push it to 5.",
    icon: "Award",
  },
  {
    id: 4,
    title: "Strong delivery presence",
    subtitle: "You're already trading on Deliveroo, Uber Eats or Just Eat – or ready to be.",
    icon: "Star",
  },
  {
    id: 5,
    title: "Ambition to grow",
    subtitle: "You see virtual brands as a real business, not a side hustle. We invest in partners who think long term.",
    icon: "Target",
  },
];

export const WHY_US = [
  {
    id: 1,
    label: "Heritage",
    title: "Built by Indians, for India’s diaspora",
    description: "We're not a generic franchise dabbling in curry. Every recipe is anchored in regional Indian techniques – Awadhi dum, Punjabi tandoor, Mumbai street – tested in our own kitchens before it ever reaches yours.",
    image: "https://images.unsplash.com/photo-1617692855027-33b14f061079",
    metric: "4 regional cuisines",
  },
  {
    id: 2,
    label: "Numbers",
    title: "Sales that make the maths work",
    description: "Our partners typically double weekly delivery sales within 90 days. Not by working harder – by selling four brands from a kitchen that used to sell one.",
    image: "https://images.unsplash.com/photo-1710091691780-c7eb0dc50cf8",
    metric: "2x weekly sales avg.",
  },
  {
    id: 3,
    label: "Marketing",
    title: "We do the spend, you bank the orders",
    description: "Performance ads, platform sponsorships, hyper-local campaigns and creative production – all run by our in-house marketing team. You wake up to incoming orders.",
    image: "https://images.pexels.com/photos/35287413/pexels-photo-35287413.jpeg",
    metric: "60+ active campaigns",
  },
  {
    id: 4,
    label: "Support",
    title: "A direct line to your Ops Manager",
    description: "No call centres, no ticket queues. Every partner gets a real human Operations Manager who knows your kitchen, your area and your numbers.",
    image: "https://images.unsplash.com/photo-1589109807644-924edf14ee09",
    metric: "WhatsApp support",
  },
  {
    id: 5,
    label: "Economics",
    title: "Group buying, your margin",
    description: "We negotiate with spice merchants, packaging suppliers and protein wholesalers across the UK. You get our prices, even if you're a one-kitchen operator.",
    image: "https://images.unsplash.com/photo-1652862729869-2f4e80c1849d",
    metric: "Up to 22% off ingredients",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    quote: "My kitchen was doing £4k a week on one takeaway brand. Six months into kitchnworx, we're at £9.5k across four. Same staff. Same hours.",
    name: "Umar A.",
    location: "Bradford",
    role: "Franchise Partner since 2024",
    image: "https://images.unsplash.com/photo-1512485800893-b08ec1ea59b1",
    metric: "+138% sales",
  },
  {
    id: 2,
    quote: "What sold me was the operations support. I have a number on WhatsApp – a real human – who looks at my data weekly and tells me exactly what to push.",
    name: "Riaz M.",
    location: "Manchester",
    role: "Franchise Partner since 2023",
    image: "https://images.pexels.com/photos/24252237/pexels-photo-24252237.jpeg",
    metric: "Top-rated kitchen",
  },
  {
    id: 3,
    quote: "Indian food sells in the UK – everyone knows that. kitchnworx made it sell properly. The recipes, the packaging, the photos – it just works on the apps.",
    name: "Shahid K.",
    location: "Leicester",
    role: "Franchise Partner since 2024",
    image: "https://images.unsplash.com/photo-1600565193348-f74bd3c7ccdf",
    metric: "4.8★ avg. rating",
  },
];

export const FAQS = [
  {
    id: 1,
    question: "What makes kitchnworx different from running my own takeaway?",
    answer: "You stop competing on a single brand. With kitchnworx, your kitchen runs four delivery-only Indian brands in parallel – each targeting a different craving. That means your weekly sales come from four pipelines instead of one, with no extra rent or staff.",
  },
  {
    id: 2,
    question: "Are you really the UK's 1st Indian virtual kitchen franchise?",
    answer: "Yes. While dark-kitchen and virtual-brand operators exist in the UK, kitchnworx is the first franchise model built end-to-end around Indian regional cuisine – fully halal, alcohol-free, with a portfolio of four brands engineered specifically for delivery platforms.",
  },
  {
    id: 3,
    question: "What is a virtual brand and how does it work?",
    answer: "A virtual brand is a delivery-only restaurant. There's no walk-in, no dine-in. Customers find it on Deliveroo, Uber Eats and Just Eat. You cook the food in your existing kitchen, package it under our brand, and the platforms deliver it.",
  },
  {
    id: 4,
    question: "Can I run kitchnworx brands from my home kitchen?",
    answer: "No. You need a fully commercial kitchen with extraction and gas or 3-phase electricity. Light commercial setups (cafes, coffee shops) and home kitchens cannot deliver the consistency our brands require.",
  },
  {
    id: 5,
    question: "How big does the kitchen need to be?",
    answer: "Approximately 25 square metres of kitchen space and 25 square metres of dry/cold storage. If your existing takeaway works, kitchnworx will fit.",
  },
  {
    id: 6,
    question: "What does it cost to start?",
    answer: "We don't charge a heavy upfront franchise fee. Most of our partners launch with under £5k of working capital for ingredients, packaging and platform setup. We share the full economics during your kitchen audit.",
  },
  {
    id: 7,
    question: "How quickly can I go live?",
    answer: "From application to live orders, the typical timeline is 14 days. Some partners have launched faster.",
  },
  {
    id: 8,
    question: "Do I have to run all four brands?",
    answer: "No. Most partners start with two brands and add the others as they scale. We'll recommend the right starting mix based on your area's demand data.",
  },
];

export const COLLAGE_IMAGES = [
  "https://images.unsplash.com/photo-1708915965975-2a950db0e215",
  "https://images.unsplash.com/photo-1600565193348-f74bd3c7ccdf",
  "https://images.unsplash.com/photo-1512485800893-b08ec1ea59b1",
  "https://images.pexels.com/photos/24252237/pexels-photo-24252237.jpeg",
];

export const HERO_BG = "https://images.unsplash.com/photo-1589109807644-924edf14ee09";
export const HERO_FOOD = "https://images.unsplash.com/photo-1589302168068-964664d93dc0";
export const COMMERCIAL_KITCHEN = "https://images.unsplash.com/photo-1708915965975-2a950db0e215";
